import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Reports from '../components/Reports';

const ReportsPage = () => {
  return (
    <div className="App bg-gray-100 min-h-screen flex flex-col">
        <Header />
        <Reports />
        <Footer />
    </div>
  );
};

export default ReportsPage;